<div
  class="pdf-dialog-wrapper"
  [class.pdf-dialog-wrapper--operational]="data.theme === 'operational'"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
>
  <div class="filter-dialog-header" cdkDragHandle>
    <h2 class="filter-dialog-title">{{ data.title || 'Detailing' }}</h2>
    <button mat-icon-button (click)="closeDialog()" aria-label="Fechar" class="filter-dialog-close">
      <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
  <div class="pdf-iframe-wrapper">
    <iframe [src]="data.url | safeUrl" frameborder="0"></iframe>
  </div>
</div>
